import { render, staticRenderFns } from "./gzExport.vue?vue&type=template&id=f1b6c2a0&scoped=true"
import script from "./gzExport.vue?vue&type=script&lang=js"
export * from "./gzExport.vue?vue&type=script&lang=js"
import style0 from "./gzExport.vue?vue&type=style&index=0&id=f1b6c2a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1b6c2a0",
  null
  
)

export default component.exports